import React, {Component, PropTypes} from 'react'
import OpeningTicketPurposePicker from '../../reference/components/OpeningTicketPurposePicker'
import {Button, ButtonToolbar, Modal} from 'react-bootstrap'
import i18n from '../../workflow/i18n'
import LoaderButton from '../../core/components/LoaderButton'
import {connect} from 'react-redux'
import {CORRECT_OTP, enterTicket} from '../actions'
import {errorStatus} from '../../core/redux/status'
import {apiOption, apiResponse, apiUrl} from '../../core/fetchz'
import config from '../../config'
import uuid from 'node-uuid'

class TicketCorrectOTPPicker extends Component {
    otpSubmit = (operation, otp) => {
        const {dispatch} = this.props
        dispatch({type: CORRECT_OTP, cmd: {operation, otp}})
    }
    qualificationChange = (e) => {
        const {dispatch} = this.props
        dispatch({type: CORRECT_OTP, cmd: e})
    }

    _submit = () => {
        const {dispatch, qualification, value, ticketUid: uid, onHide} = this.props

        const options = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                otpLabel: value.label,
                otpUid: value.uid,
                commandType: 'CorrectOpeningTicketPurpose',
                ...(qualification && qualification.length > 0 ? {qualification: qualification} : {}),
            },
        }

        fetch(apiUrl(`${config.api.event.url}/tickets/${uid}`), apiOption(options))
            .then(apiResponse)
            .then(() => {
                onHide()
                return enterTicket(dispatch, {id: uid})
            })
            .catch((e) => {
                dispatch(errorStatus(e.message))
            })
    }

    render = () => {
        const {company, onHide, show, value, qualification} = this.props

        return (

            <Modal
                bsSize='large'
                show={show}
                onHide={onHide}
            >
                <Modal.Header>
                    <Modal.Title>{i18n.identifiedRequests}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OpeningTicketPurposePicker
                        company={company}
                        value={value}
                        qualification={qualification}
                        onSubmit={this.otpSubmit}
                        onQualificationChange={this.qualificationChange}
                    />
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            // className={cx({disabled: !form.isValid()})}
                            onClick={this._submit}
                            >
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}
                            >
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>

            )
    }
}

export default connect(({ticket}) => {
    const {cmdCorrectOTP} = ticket || {}
    return cmdCorrectOTP
})(TicketCorrectOTPPicker)


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketCorrectOTPPicker.js